import request from '../utils/request'

export function getLogin (data) {
  return request({
    url: '/api/wechat/mp-login',
    method: 'get',
    params:data,
  })
}
export function systemConfig () {
  return request({
    url: '/api/basic/system-config',
    method: 'get'
  })
}
